export default "__VITE_ASSET__DPCqnJ1P__"